import { GET_CUSTOMER_DETAILS_RESPONSE, GET_REQUEST_STATUS, GET_CUSTOMERS_RESPONSE } from './types';

const INITIAL_STATE = {
  list: [],
  meta: {},
  customerDetails: null,
  requestStatus: null,
};

const customers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CUSTOMERS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta === null ? {} : action.payload.meta,
      };
    case GET_CUSTOMER_DETAILS_RESPONSE:
      return {
        ...state,
        customerDetails: action.payload,
      };
    case GET_REQUEST_STATUS:
      return {
        ...state,
        requestStatus: action.payload === null ? null : action.payload,
      };

    default:
      return state;
  }
};

export default customers;
